// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#CatalogFormDialog .button-icon{border-radius:5px;cursor:pointer}#CatalogFormDialog .button-icon:hover{background:var(--primary)}#CatalogFormDialog .button-icon:hover img{filter:invert(100%);-webkit-filter:invert(100%);-moz-filter:invert(100%);-ms-filter:invert(100%);-o-filter:invert(100%)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
